import React, { FunctionComponent, useCallback } from "react";
import { Toggle } from "../../components/forms/toggle";
import { Loader } from "../../components/loader";
import { useAppLoader } from "../../components/loader/app-loader-hook";
import { Widget } from "../../components/widget";
import { useFetchable } from "../../store/common/fetchable";
import { VerificationDTO } from "../../store/verification/models/dto/kyc";
import { ServiceType } from "../../store/verification/models/internal";
import { Verification } from "../../store/verification/reducer";
import { VerificationService } from "../../store/verification/service";
import { mapObject } from "../../utils/utils";

export const MerchantServices: React.FunctionComponent<{}> = () => {
  const data = useFetchable(Verification.currentMerchantConfig);
  return <Loader data={[data]}>{([data]) => <InnerPage data={data} />}</Loader>;
};

const InnerPage: FunctionComponent<{
  data: VerificationDTO.Responses.GetMerchantConfig.T;
}> = ({ data }) => {
  const loader = useAppLoader();
  const toggle = useCallback(
    (val: typeof ServiceType.T) => {
      if (data.includedServices.includes(val)) {
        loader(VerificationService.removeServiceToMerchantConfig(val));
      } else {
        loader(VerificationService.addServiceToMerchantConfig(val));
      }
    },
    [data]
  );

  return (
    <Widget title="Services Enabled">
      {mapObject(ServiceType.enum, (val, key) => (
        <div key={key}>
          <Toggle
            label={val}
            onChange={() => toggle(key)}
            value={data.includedServices.includes(key)}
          />
        </div>
      ))}
    </Widget>
  );
};
